import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { FormFieldModel } from './form-field.model';

export class ImageEffectsFieldModel implements FormFieldModel {
    property: string;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    label?: string;
    description?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
    }
}
